<template>
    <div>
        <!-- 如果存在手机号，则通过手机号验证 -->
        <el-card style='margin-top: 2rem;' class='box-card'>
            <div slot='header' class='clearfix'>
                <h3>{{ $t('account.changePassword') || '修改密码' }}</h3>
            </div>
            <div v-if='!userInfo.passwordStatus'>
                <el-form :model='userPassword' status-icon :rules='rules' ref='updatePwdNoPhone' label-width='100px'
                         class='demo-ruleForm'>
                    <el-form-item :label="$t('account.newPassword') || '密码'" prop='password' key='password'>
                        <el-input show-password type='password' v-model='userPassword.password'
                                  autocomplete='off'></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('account.confirmPassword') || '确认密码'" prop='newPassword'
                                  key='newPassword'>
                        <el-input show-password type='password' v-model='userPassword.newPassword'
                                  autocomplete='off'></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type='primary' @click="updatePassword('updatePwdNoPhone')">
                            {{ $t('common.modify') || '修改' }}
                        </el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div v-else>
                <div v-if='userInfo.phone || userInfo.email'>
                    <el-form label-position='left' ref='updatePwdByPhone' :rules='rules' :model='userPassword'
                             label-width='80px'>
                        <el-form-item :label="$t('login.verifyCode') || '验证码'" key='captcha' prop='captcha'>
                            <el-input type='number' v-model='userPassword.captcha' style='width: 50%'
                                      :placeholder="$t('account.enterVerifyCode') || '请输验证码'" />
                            &nbsp;&nbsp;<el-button type='text' :disabled='userPassword.sendCaptchaStatus'
                                                   @click='updatePwdSendCaptchaByAccount'>
                            {{ userPassword.sendCaptchaStatus ? `${userPassword.resendTime}${$t('login.resendAfterSend') || '秒后重新发送'}` : $t('login.sendVerifyCode') || '发送验证码'
                            }}
                        </el-button>
                        </el-form-item>
                        
                        <el-form-item :label="$t('account.newPassword') || '密码'" prop='password' key='password'>
                            <el-input show-password type='password' v-model='userPassword.password'
                                      autocomplete='off'></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('account.confirmPassword') || '确认密码'" prop='newPassword'
                                      key='newPassword'>
                            <el-input show-password type='password' v-model='userPassword.newPassword'
                                      autocomplete='off'></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type='primary' @click="updatePwdByPhone('updatePwdByPhone')">
                                {{ $t('common.modify') || '修改' }}
                            </el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div v-else>
                    <el-form :model='userPassword' status-icon :rules='rules' label-position='left' ref='updatePwdPhone'
                             label-width='100px'
                             class='demo-ruleForm'>
                        <el-form-item :label="$t('account.oldPassword') || '原密码'" prop='originPassword'
                                      key='originPassword'>
                            <el-input show-password type='password' v-model='userPassword.originPassword'
                                      autocomplete='off'></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('account.newPassword') || '密码'" prop='password' key='password'>
                            <el-input show-password type='password' v-model='userPassword.password'
                                      autocomplete='off'></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('account.confirmPassword') || '确认密码'" prop='newPassword'
                                      key='newPassword'>
                            <el-input show-password type='password' v-model='userPassword.newPassword'
                                      autocomplete='off'></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type='primary' @click="updatePassword('updatePwdPhone')">
                                {{ $t('common.modify') || '修改' }}
                            </el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </el-card>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import { accountApi } from '@/service/api/accountApi';
import { message } from '@/utils/message';
import AddOrUpdateEmail from '@view/account/AddOrUpdateEmail.vue';
import AddOrUpdatePhone from '@view/account/AddOrUpdatePhone.vue';

export default defineComponent({
    name: 'UpdatePassword',
    components: { AddOrUpdatePhone, AddOrUpdateEmail },
    props: {
        userInfo: {
            type: Object
        }
    },
    data() {
        let validatePass = (rule, value, callback) => {
            if (!value) {
                callback(new Error(this.$t('account.enterPassword') || '请输入密码'));
            } else {
                callback();
            }
        };
        let originValidatePass = (rule, value, callback) => {
            if (!value) {
                callback(new Error(this.$t('account.enterOldPassword') || '请输入原密码'));
            } else {
                callback();
            }
        };
        let validatePass2 = (rule, value, callback) => {
            if (!value) {
                callback(new Error(this.$t('account.enterPasswordAgain') || '请再次输入密码'));
            } else if (value !== this.userPassword.password) {
                callback(new Error(this.$t('account.passwordNotMatch') || '两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        return {
            updateUserInfoStatus: {
                updateAccount: false,
                updateEmail: false,
                updatePhone: false
            },
            phoneExistStatus: false,
            captchaInfo: {
                captcha: '',
                verifyStatus: false,
                resendTime: 60,
                phone: undefined,
                sendCaptchaStatus: false
            },
            warningMsgList: [],
            time: undefined,
            updatePwdTime: undefined,
            rules: {
                password: [
                    { validator: validatePass, trigger: 'blur' }
                ],
                newPassword: [
                    { validator: validatePass2, trigger: 'blur' }
                ],
                originPassword: [
                    { validator: originValidatePass, trigger: 'blur' }
                ],
                phone: [
                    {
                        validator: (rule, value, callback) => {
                            if (!value) {
                                callback(new Error(this.$t('account.enterPhone') || '请输入手机号'));
                            } else {
                                callback();
                            }
                        }
                    }
                ],
                captcha: [
                    {
                        validator: (rule, value, callback) => {
                            if (!value) {
                                callback(new Error(this.$t('login.enterVerifyCode') || '请输入验证码'));
                            } else {
                                callback();
                            }
                        }
                    }
                ],
                account: [
                    {
                        validator: (rule, value, callback) => {
                            if (!value) {
                                callback(new Error(this.$t('login.enterAccount') || '请输入账号'));
                            } else {
                                callback();
                            }
                        }
                    }
                ]
            },
            userPassword: {
                password: undefined,
                newPassword: undefined,
                originPassword: undefined,
                sendCaptchaStatus: false,
                resendTime: 60,
                captcha: undefined
            }
        };
    },
    created() {
        this.setPhoneExistStatus();
    },
    computed: {
        computedPlatformArr() {
            if (!this.userInfo.platform) {
                return [];
            }
            return this.userInfo.platform.split(',');
        }
    },
    methods: {
        submitUpdateUserInfo() {
            this.$refs.updateAccountInfo.validate((valid) => {
                if (!valid) {
                    return false;
                }
                accountApi.updateUserInfo(this.userInfo).then(result => {
                    if (result.code === 200) {
                        message.success(this.$t('account.changeSuccess') || '更改成功');
                    }
                });
            });
        },
        formValidate(formName) {
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    return false;
                }
            });
        },
        updatePwdSendCaptchaByAccount() {
            this.setPhoneExistStatus();
            if (this.phoneExistStatus) {
                accountApi.sendPhoneCaptchaByAccount({ account: this.userInfo.account }).then(result => {
                    if (result.code === 200) {
                        message.success(this.$t('account.codeSentCheckBoundPhone') || '验证码已发送，请检查该账号绑定的手机号');
                        this.userPassword.sendCaptchaStatus = true;
                        this.updatePwdTime = setInterval(() => {
                            if (this.userPassword.resendTime <= 1) {
                                clearInterval(this.updatePwdTime);
                                this.userPassword.resendTime = 60;
                                this.userPassword.sendCaptchaStatus = false;
                            } else {
                                this.userPassword.resendTime = this.userPassword.resendTime - 1;
                            }
                        }, 1000);
                    }
                });
            } else {
                accountApi.sendEmailCaptchaByAccount({ account: this.userInfo.account }).then(result => {
                    if (result.code === 200) {
                        message.success(this.$t('account.codeSentCheckBoundEmail') || '验证码已发送，请检查该账号绑定的邮箱');
                        this.userPassword.sendCaptchaStatus = true;
                        this.updatePwdTime = setInterval(() => {
                            if (this.userPassword.resendTime <= 1) {
                                clearInterval(this.updatePwdTime);
                                this.userPassword.resendTime = 60;
                                this.userPassword.sendCaptchaStatus = false;
                            } else {
                                this.userPassword.resendTime = this.userPassword.resendTime - 1;
                            }
                        }, 1000);
                    }
                });
            }
        },
        updatePassword(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    accountApi.updatePassword({
                        password: this.userPassword.originPassword,
                        newPassword: this.userPassword.newPassword
                    }).then(result => {
                        if (result.code === 200) {
                            message.success(this.$t('account.modifySuccess') || '修改成功');
                            this.getUserInfo();
                        }
                    });
                } else {
                    return false;
                }
            });
        },
        
        updatePwdByPhone(formName) {
            this.setPhoneExistStatus();
            this.$refs[formName].validate(valid => {
                if (!valid) {
                    return false;
                }
                
                if (this.phoneExistStatus) {
                    accountApi.updatePasswordByPhone({
                        phone: this.userInfo.phone, captcha: this.userPassword.captcha,
                        password: this.userPassword.password
                    }).then(result => {
                        if (result.code === 200) {
                            message.success(this.$t('account.modifySuccess') || '修改成功');
                            this.resetUserPassword();
                        }
                    });
                } else {
                    accountApi.updatePasswordByEmail({
                        email: this.userInfo.email, captcha: this.userPassword.captcha,
                        password: this.userPassword.password
                    }).then(result => {
                        if (result.code === 200) {
                            message.success(this.$t('account.modifySuccess') || '修改成功');
                            this.resetUserPassword();
                        }
                    });
                }
            });
        },
        resetUserPassword() {
            this.userPassword = {
                password: undefined,
                newPassword: undefined,
                originPassword: undefined,
                sendCaptchaStatus: false,
                resendTime: 60,
                captcha: undefined
            };
        },
        setPhoneExistStatus() {
            this.phoneExistStatus = !!this.userInfo.phone;
        }
    }
});
</script>

<style scoped lang='css'>
.account-input {
    width: 40%;
}
</style>
